/**
 * Checks if an Object is empty
 *
 * @param {Object} object Object to check
 * @return {boolean} if object is empty or not
 */
export const isEmptyObject = (object: Object) => {
	return Object.keys(object).length === 0;
};
